import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./style.css";
import saveToApm from "../../apm";

const PopupBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [cookieAccepted, setCookieAccepted] = useState(false);

  useEffect(() => {
    const hasAcceptedCookies = Cookies.get("cookieAccepted") === "true";
    setCookieAccepted(hasAcceptedCookies);

    if (!hasAcceptedCookies) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    Cookies.set("cookieAccepted", "true", { expires: 365 });
    setShowBanner(false);
    setCookieAccepted(true);
    saveToApm("Cookies Accepted.")
  };

  const declineCookies = () => {
    alert(
      "You have declined cookies. Some features of this website may not work as expected.",
    );
    setShowBanner(false);
    saveToApm("Cookies Declined.")
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-popup">
      <div className="popup-content">
        <p className="cookie-text">
          This website uses cookies to enhance your experience and for analytics
          and compliance purposes. By using this website, you agree to our use
          of cookies.
        </p>
        <div className="button-container">
          <button className="accept-button" onClick={acceptCookies}>
            Accept
          </button>
          <button className="decline-button" onClick={declineCookies}>
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupBanner;
